/* eslint-disable */
module.exports = function(price, formatInfos, formatPattern) {

  const priceFormatterInfos = formatInfos || window.priceFormatterInfos;

  if(priceFormatterInfos !== undefined) {
    const formatCurrency = priceFormatterInfos.currency.symbol;
    const formatThousandSeparator = priceFormatterInfos.format.thousands.separator;
    const decimalPattern = priceFormatterInfos.format.decimalPattern;
    const undefinedPlaceholder = '-';
    const fromMessage = window.Messages('product.price.format.from');
    let unit;
    let decimal;
    let formattedPrice;
    const decimals = decimalPattern.split('.')[1];
    const preferIntegers = priceFormatterInfos.format.preferIntegers;
    // Set pattern based on keyword given in the param (default to `light`)
    let customFormatPattern = priceFormatterInfos.format.pattern[formatPattern] || priceFormatterInfos.format.pattern.light;
    // if pattern keyword used is 'extended' then we use `default` pattern
    if (formatPattern === 'extended')
      customFormatPattern = priceFormatterInfos.format.pattern.default;

    const priceStr = String(price);
    price = priceStr.toString();

    if(price && !price.match("^(?=.*[a-zA-Z])(?=.*[0-9])")) {

      // Force a 2 decimals number
      if (decimals)
        price = parseFloat(price).toFixed(decimals.length);
      else
        price = parseInt(price);


      // Split the number to get separated `unit` & `decimal`
      const priceSplit = String(price).split('.');

      unit = priceSplit[0];
      decimal = priceSplit[1] ? priceSplit[1] : undefinedPlaceholder;
      if(preferIntegers && decimal === '00') {
          // switch pattern to integer only
         // customFormatPattern = customFormatPattern + 'Integer';
          customFormatPattern = priceFormatterInfos.format.pattern[formatPattern + 'Integer'] || priceFormatterInfos.format.pattern.lightInteger;
       }


      // Change `unit` to add eventual thousands separators
      if(formatThousandSeparator !== '' && formatThousandSeparator !== undefined) {

        const reverseUnitSplit = unit.split('').reverse();

        const unitTemp = [];

        reverseUnitSplit.forEach(function(v, i) {
          unitTemp.push(v);

          if((i + 1) % 3 === 0 && ((i + 1) !== reverseUnitSplit.length)) {
            unitTemp.push(formatThousandSeparator);
          }
        });

        unit = unitTemp.reverse().join('');
      }
      //

    } else {
      unit = undefinedPlaceholder;
      decimal = undefinedPlaceholder;
    }

    // get formatted price based on pattern
    formattedPrice = customFormatPattern.replace('%1$s', unit).replace('%2$s', decimal).replace('%3$s', formatCurrency).replace('%4$s', fromMessage);
    return formattedPrice;
  }
}



// WEBPACK FOOTER //
// ./src/modules-es5/commons/lib/lib-price-formatter.js